//#region src/components/ScalarWrappingText/constants.ts
/**
* A list of preset regexes for word breaks
*/
var PRESETS = {
	/** Breaks on `/`, '.' and `-` for urls or file paths */
	"path": /[\/\.-]/,
	/**
	* Breaks on capitals, `_` and `.` for properties written in
	* camel, pascal or snake case
	*/
	"property": /[A-Z\_\.-]/
};
//#endregion
export { PRESETS };

//# sourceMappingURL=constants.js.map